import { ElMessageBox, ElMessage } from 'element-plus';

export function copy(text) {
    // text: 要复制的内容， callback: 回调
    // 使用 textarea 而非 input：input 会丢弃换行符，多行内容会被压成一行
    var tag = document.createElement('textarea');
    tag.setAttribute('id', 'at___cp_input');
    // 移出可视区域并脱离文档流，避免复制时的闪烁与页面滚动跳动
    tag.style.position = 'fixed';
    tag.style.top = '-2000px';
    tag.style.left = '-2000px';
    tag.style.opacity = '0';
    tag.value = text;
    document.getElementsByTagName('body')[0].appendChild(tag);
    document.getElementById('at___cp_input').select();
    document.execCommand('copy');
    document.getElementById('at___cp_input').remove();
}
